import { MAX_PHOTO_BYTES } from './constants'
import { ArchiveError } from './errors'
import type { PhotoRef } from './imageIndex'
import { readZipEntryBlob } from './zip'

export async function readPhotoBlob(file: Blob, photo: PhotoRef): Promise<Blob> {
  if (photo.kind === 'packed') throw new ArchiveError('compressed')
  if (photo.size > MAX_PHOTO_BYTES || photo.uncompressedSize > MAX_PHOTO_BYTES)
    throw new ArchiveError('photo-too-large')
  if (photo.kind === 'raw') return file.slice(photo.offset, photo.offset + photo.size)
  return readZipEntryBlob(file, photo)
}
